// ============================================================
// TanStack Query Key Factory
// Follows convention from architecture.md
// ============================================================

export const userKeys = {
  all: ['users'] as const,
  me: () => [...userKeys.all, 'me'] as const,
  locations: () => [...userKeys.all, 'locations'] as const,
  detail: (id: string) => [...userKeys.all, 'detail', id] as const,
  lists: () => [...userKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...userKeys.lists(), filters] as const,
};

export const configKeys = {
  all: ['config'] as const,
  system: () => [...configKeys.all, 'system'] as const,
  vehicleTypes: () => [...configKeys.all, 'vehicleTypes'] as const,
};

export const claimKeys = {
  all: ['claims'] as const,
  lists: () => [...claimKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...claimKeys.lists(), filters] as const,
  detail: (id: string) => [...claimKeys.all, 'detail', id] as const,
};
